import axios from "axios";

import Cookies from 'universal-cookie';



const cookie = new Cookies();



// Base API URL (default to local dev if env not provided)
export const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8082"


export const performRequest = (
    method,
    url,
    params,
    login = true,
    type = "json",
) => {
    const body = (method === "get" || method === "delete" ) ? "params" : "data";
    const config = {
        method,
        url,
        baseURL: API_URL,
        [body]: params || {},
        responseType: type,

    };
 
    config.headers = {
        "Content-Type": "application/json; charset=utf-8",
    };
    
    if (login) {
        // let token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzM4NzQxOTEzLCJpYXQiOjE3MzAxMDE5MTMsImp0aSI6IjU4NzYzODg4NmI2NzQ1NDU5YmFlZDEwMTUyMTdlNWY0IiwidXNlcl9pZCI6NH0.kxKddpjQfkQdapCbzI6dtCb1H4Je4kSZIXEiwF7-RVc"
        //"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzM4NjUwODE2LCJpYXQiOjE3MzAwMTA4MTYsImp0aSI6IjM1YWRkMWFhY2YxZTRkOTlhNWM1OWYxNjdlNTM1YzNlIiwidXNlcl9pZCI6NH0.ebXPE6Z45d0i6Y6YwipCUI9xfZM9CMrTCVysBvKVKGk"
        config.headers.Authorization = "Bearer " + cookie.get('token');

    }
    const company = localStorage.getItem('company') || 1
    if (company) {
      const params = config.params || {}
      params.company = company
      config.params = params
    }
  
    return axios.request(config);
    // Add a request interceptor
};

// axios.interceptors.response.use(
//     (response) => {
//         return response;
//     },
//     function (error) {
//         // const token = localStorage.getItem("accessToken");
//         const token = cookie.get("accessToken");

//         const {
//             config,
//             response: { status },
//         } = error;
//         const originalRequest = config;
//         if (status === 403) {
//             performRequest("post", "api-token-refresh/", { token: token })
//                 .then((response) => {
//                     cookie.set('accessToken', response.data.token, { path: '/', secure: true, sameSite: true });

//                     // localStorage.setItem("accessToken", response.data.token);
//                 })
//                 .catch((error) => {
//                     cookie.remove("accessToken");
//                     localStorage.removeItem("enterprise")


//                     this.props.setEnterprise("")

//                     window.location = "/";
//                 });
//         }
//         return Promise.reject(error);
//     }
// );
